module.exports = __webpack_public_path__ + "img/successrocket.df1fa8e9.svg";